import { render, staticRenderFns } from "./ObservationsPage.vue?vue&type=template&id=a7b44c7e&scoped=true&"
import script from "./ObservationsPage.vue?vue&type=script&lang=js&"
export * from "./ObservationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b44c7e",
  null
  
)

export default component.exports